import { createFileRoute } from "@tanstack/react-router";
import BulkEditPage from "lib/components/options/catalog/edit/BulkEditPage";
import { useAppRouterParams } from "lib/routeHelpers";
import withAuthentication from "../../../../../components/withAuthentication";

function BulkEditOptions() {
  const { builderId } = useAppRouterParams();
  if (!builderId) {
    return null;
  }
  return <BulkEditPage builderId={builderId} type="options" />;
}

export const Route = createFileRoute("/builders/$builder_id/options/edit/options")({
  component: withAuthentication(BulkEditOptions, {
    permissions: ["VIEW_OPTION_CATALOG", "EDIT_OPTION_CATALOG"],
    permissionOperator: "AND",
    features: ["nextGenOptions"],
  }),
});
